<template>
  <el-autocomplete :value="displayValue" :fetch-suggestions="querySuggestions" :trigger-on-focus="false" placeholder="输入地址并选择联想结果" clearable class="waybill-location-input" @input="onInput" @select="selectLocation">
    <template v-if="$slots.append" slot="append"><slot name="append" /></template>
    <template slot-scope="{ item }"><div>{{ item.name }}</div><small class="location-context">{{ item.context }}</small></template>
  </el-autocomplete>
</template>

<script>
import { setAmapSecurityConfig, loadAmapSDK } from '@/utils/amapConfig'
import { queryLocationSuggestions, reverseLocation, locationPoint } from './waybillLocation'
import { buildFullAddress } from './locationArea'

export default {
  name: 'WaybillLocationInput',
  props: { value: { type: String, default: '' }, locationContext: { type: Object, default: null } },
  data() { return { requestSequence: 0, querySequence: 0, inputValue: null } },
  computed: {
    displayValue() {
      const node = this.locationContext
      return node && node.lonLat ? buildFullAddress(node.areaCodes, this.value) : this.value
    }
  },
  beforeDestroy() { this.requestSequence++; this.querySequence++ },
  methods: {
    requestGuard(sequenceKey = 'requestSequence') {
      const requestId = ++this[sequenceKey]
      const node = this.locationContext
      const coordinate = node && node.lonLat
      const address = node && node.address
      const areaCodes = node && String(node.areaCodes || '')
      const value = this.value
      const ownInput = this.inputValue
      // 联想自身的 input→select 可以同一轮发生；外部选点、换节点必须使旧请求失效。
      return () => requestId === this[sequenceKey] && node === this.locationContext
        && (!node || (node.lonLat === coordinate && node.address === address && String(node.areaCodes || '') === areaCodes))
        && (this.value === value || (ownInput !== null && this.value === ownInput))
    },
    onInput(value) {
      if (value === this.displayValue) return
      this.requestSequence++
      this.querySequence++
      this.inputValue = value
      this.$emit('input', value)
      this.$emit('unlocated')
    },
    async querySuggestions(keyword, callback) {
      const current = this.requestGuard('querySequence')
      try {
        setAmapSecurityConfig()
        await loadAmapSDK(['AMap.AutoComplete', 'AMap.Geocoder'])
        if (!current()) return
        queryLocationSuggestions(window.AMap, keyword, items => { if (current()) callback(items) })
      } catch (error) {
        if (current()) { callback([]); this.$message.warning('地址联想失败，请重试或使用地图选点') }
      }
    },
    async selectLocation(item) {
      const current = this.requestGuard()
      const point = locationPoint(item && item.location)
      if (!point) return
      try {
        const result = await reverseLocation(window.AMap, point[0], point[1])
        if (!current()) return
        if (!result || result.areaCodes.length !== 3) { this.$message.warning('未获取完整地区，请使用地图选点'); return }
        if (item.name && !String(result.address || '').includes(item.name)) result.address = `${result.address || ''}${item.name}`
        this.$emit('confirm', result)
      } catch (error) {
        if (current()) this.$message.warning('地址解析失败，请使用地图选点')
      }
    }
  }
}
</script>

<style scoped>
.waybill-location-input { width: 100%; }.location-context { display: block; overflow: hidden; color: #909399; text-overflow: ellipsis; white-space: nowrap; }
.waybill-location-input ::v-deep .el-input-group__append { padding: 0; }
</style>
